import React from 'react'
import PropTypes from 'prop-types'
import { formValues } from 'redux-form'
import CampaignsCard from './campaigns-card'
import TierResponsesCard from './tier-responses-card'
import SpecialMomentCard from './special-moment-card'

// Pulse Intelligence (FNB) config section. Each card persists under
// widget_data.intentBased via redux-form's `change`. Future cards (missed-post
// redirect, repeat fallback, special moment) mount here too, so the section
// stays between Experience Ownership and Triggers and Actions.
export const PulseIntelligence = ({
  change,
  campaign,
  ownerId,
  tierResponses,
  tierPointsEnabled,
  pointBonuses,
  repeatResponse,
  specialMoment
}) => (
  <div>
    <CampaignsCard
      ownerId={ownerId}
      campaign={campaign}
      onChange={next => change('intentBased.campaign', next)}
    />
    <TierResponsesCard
      tiers={tierResponses}
      pointsEnabled={tierPointsEnabled === true}
      pointBonuses={pointBonuses}
      repeatResponse={repeatResponse}
      change={change}
    />
    <SpecialMomentCard specialMoment={specialMoment} change={change} />
  </div>
)

PulseIntelligence.propTypes = {
  change: PropTypes.func.isRequired,
  campaign: PropTypes.object,
  ownerId: PropTypes.string,
  tierResponses: PropTypes.array,
  tierPointsEnabled: PropTypes.bool,
  pointBonuses: PropTypes.object,
  repeatResponse: PropTypes.object,
  specialMoment: PropTypes.object
}

const ConfigurePulseIntelligence = formValues({
  campaign: 'intentBased.campaign',
  ownerId: 'ownerId',
  tierResponses: 'intentBased.tierResponses',
  tierPointsEnabled: 'intentBased.tierPointsEnabled',
  pointBonuses: 'intentBased.pointBonuses',
  repeatResponse: 'intentBased.repeatResponse',
  specialMoment: 'intentBased.specialMoment'
})(PulseIntelligence)

ConfigurePulseIntelligence.displayName = 'ConfigurePulseIntelligence'

export default ConfigurePulseIntelligence



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-pulse-intelligence/index.js